import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";
import PaymentConfigurationView from "@/modules/payment-config/views/PaymentConfigurationView";
import {CustomerProfileManagementView} from "@/views/profile/CustomerProfileManagementView";
import PaymentProcessesPage from "@/modules/admin/fsps/PaymentProcessesPage";
import FSPManagementView from "@/modules/payment-config/views/FSPManagementView";

export const paymentConfigRoutes: RouteObject[] = [
    {
        path: '/admin/payment-settings/payment-configuration',
        element: <PaymentConfigurationView />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: 'admin/payment-settings/payment-customer-profile',
        element: <CustomerProfileManagementView />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: 'admin/payment-settings/payment-process',
        element: <PaymentProcessesPage />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: 'admin/payment-settings/fsps',
        element: <FSPManagementView />,
        errorElement: <ErrorBoundary />,
    }
];